import vCodeDisplay from "./v-code-display.vue";

export default Vue => {
  Vue.component("v-code-display", vCodeDisplay);
};
